<template>
	<svg viewBox="0 0 32 32">
		<path d="M3.333 25.333h25.337v2.667h-25.337zM29.427 12.846c-0.237-0.86-1.012-1.481-1.931-1.481-0.183 0-0.361 0.025-0.53 0.071l0.014-0.003-7.087 1.9-9.2-8.58-2.573 0.693 5.52 9.567-6.627 1.773-2.62-2.063-1.933 0.52 3.447 5.98 22.107-5.926c0.86-0.237 1.481-1.012 1.481-1.931 0-0.183-0.025-0.361-0.071-0.53l0.003 0.014z" />
	</svg>
</template>
